/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptions } from './FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptions';
import {
    instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptions,
    FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsFromJSON,
    FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsFromJSONTyped,
    FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsToJSON,
} from './FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptions';

/**
 * @type FxIdDomainSettingsPublicWebClientConfigOptionsStorePage
 * Настройки для страницы магазина
 * @export
 */
export type FxIdDomainSettingsPublicWebClientConfigOptionsStorePage = FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptions;

export function FxIdDomainSettingsPublicWebClientConfigOptionsStorePageFromJSON(json: any): FxIdDomainSettingsPublicWebClientConfigOptionsStorePage {
    return FxIdDomainSettingsPublicWebClientConfigOptionsStorePageFromJSONTyped(json, false);
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsStorePageFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainSettingsPublicWebClientConfigOptionsStorePage {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptions(json)) {
        return FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsStorePageToJSON(json: any): any {
    return FxIdDomainSettingsPublicWebClientConfigOptionsStorePageToJSONTyped(json, false);
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsStorePageToJSONTyped(value?: FxIdDomainSettingsPublicWebClientConfigOptionsStorePage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptions(value)) {
        return FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsToJSON(value as FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptions);
    }

    return {};
}

